import { useAccountApi } from './useAccountApi';
import { useAccountGetters } from './useAccountGetters';
import { useAccountHelpers } from './useAccountHelpers';

import type { UseAccount } from './types';
export function useAccount(): UseAccount {
  return {
    ...useAccountApi(),
    ...useAccountGetters(),
    ...useAccountHelpers(),
  };
}
